import React from "react";
import { useSearch } from "../../../../contexts/SearchContext";
import DestinationInput from "../SubComponents/DestinationInput/DestinationInput";
import PeopleCounterInput from "../SubComponents/PeopleCounterInput/PeopleCounterInput";
import "./organizedTourSearchBar.css";
import { getAvailableMonthOfDeparture } from "../../../../contexts/SearchContextHelpers";
import { Loader } from "../../../Loader/Loader";
import { ConfigProvider, DatePicker, Select, Tooltip } from "antd";
import he_IL from "antd/locale/he_IL";
import dayjs from "dayjs";
import "dayjs/locale/he";

dayjs.locale(
  "he",
  {
    months: [
      "ינואר",
      "פברואר",
      "מרץ",
      "אפריל",
      "מאי",
      "יוני",
      "יולי",
      "אוגוסט",
      "ספטמבר",
      "אוקטובר",
      "נובמבר",
      "דצמבר",
    ],
    formats: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D [ב]MMMM YYYY",
      LLL: "D [ב]MMMM YYYY HH:mm",
      LLLL: "dddd, D [ב]MMMM YYYY HH:mm",
    },
    monthsShort: [
      "ינו׳",
      "פבר׳",
      "מרץ",
      "אפר׳",
      "מאי",
      "יוני",
      "יולי",
      "אוג׳",
      "ספט׳",
      "אוק׳",
      "נוב׳",
      "דצמ׳",
    ],
    weekdays: ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"],
    weekdaysShort: ["א׳", "ב׳", "ג׳", "ד׳", "ה׳", "ו׳", "ש׳"],
    weekdaysMin: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
    name: "Hebrew",
    ordinal: (number) => {
      const suffixes = ["", "א", "ב", "ג", "ד", "ה", "ו", "ז", "ח", "ט"];
      return number + (suffixes[number % 10] || "");
    },
    week: {
      dow: 0, // Sunday is the first day of the week.
      doy: 6, // The week that contains Jan 1st is the first week of the year.
    },
    weekStart: 0, // Sunday is the first day of the week.
    relativeTime: {
      d: "יום",
      dd: "ימים",
      M: "חודש",
      MM: "חודשים",
      y: "שנה",
      yy: "שנים",
      future: (s) => `בעוד ${s}`,
      past: (s) => `לפני ${s}`,
      h: "שעה",
      hh: "שעות",
      m: "דקה",
      mm: "דקות",
      s: "שניות",
    },
  },
  true
);

export const dateHebLocale = {
  ...he_IL.DatePicker,
  lang: {
    ...he_IL.DatePicker.lang,
  },
};

const OrganizedTourSearchBar = () => {
  const {
    setTourMonth,
    setCategories,
    categories,
    roomInfo,
    setRoomInfo,
    location,
    setLocation,
    ldsDates,
    datesError,
    loadingDates,
    subjects,
  } = useSearch();

  function renderInput() {
    const defaultProps = {
      width: 120,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    };
    if (datesError) {
      return <div style={{ ...defaultProps }}>{datesError}</div>;
    }
    if ((!location || location.length === 0) && !ldsDates) {
      return <div style={{ ...defaultProps }}>יש לבחור יעד</div>;
    }
    if (loadingDates) {
      return (
        <div
          style={{
            ...defaultProps,
          }}
        >
          <Loader size="small" />
        </div>
      );
    }
    const availableMonths = getAvailableMonthOfDeparture(ldsDates);

    const disabledDate = (current) => {
      // Can not select days before today and today
      return (
        current && availableMonths.indexOf(current.format("MM/YYYY")) === -1
      );
    };

    return (
      <Tooltip
        title={
          location === ""
            ? "בחר תאריכים"
            : availableMonths.length === 0
              ? "אין תאריכים זמינים"
              : undefined
        }
      >
        <ConfigProvider locale={he_IL}>
          <DatePicker.MonthPicker
            format="MM/YYYY"
            defaultValue={undefined}
            disabledDate={disabledDate}
            disabled={location === "" || availableMonths.length === 0}
            onChange={(date, dateString) => {
              setTourMonth(dateString);
            }}
            locale={dateHebLocale}
          />
        </ConfigProvider>
      </Tooltip>
    );
  }

  return (
    <>
      <PeopleCounterInput
        roomInfo={roomInfo}
        setRoomInfo={setRoomInfo}
        isTour={true}
      />
      <Select
        placeholder="סוג"
        value={categories[0]}
        options={[
          ...subjects["OrganizedTours"].map((category) => ({
            value: category,
            label: category,
          })),
        ]}
        onChange={(value) => {
          setCategories([value]);
        }}
        style={{ width: 200, height: "57px" }}
      />
      <DestinationInput
        location={location}
        setLocation={setLocation}
        isLdsInput
        isOrganizedTour={true}
      />
      {renderInput()}
      {/*<div>שים לב, החיפוש יופעל עם טווח של -+2 ימים</div>*/}
    </>
  );
};

export default OrganizedTourSearchBar;
